<div class="center">
  <form [formGroup]="formGroup" class="flex-col width-800">
    <h2 class="center margin-y-10">
      Create DAPR Reset Me rule
    </h2>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Services:</label>
      <ng-select formControlName="services" name="services" placeholder="Select services"
        class="flex-grow font-20 margin-l-10" [items]="services" bindValue="id" bindLabel="label"
        [multiple]="true" [hideSelected]="true">
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Rule Name:</label>
      <input formControlName="ruleName" name="ruleName" placeholder="Rule Name" class="flex-grow font-20 margin-l-10" />
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Purchase Start Date:</label>
      <p-calendar formControlName="startDate" icon="pi pi-calendar" class="font-20 margin-l-10" name="startDate"
        [showIcon]="true" dateFormat="d/m/yy" (ngModelChange)="changeInDate()" [minDate]="today" [defaultDate]="today"
        [maxDate]="maxStartDate" [selectOtherMonths]="true" showTime="true" hourFormat="24" [showButtonBar]="true"
        [stepMinute]="30">
      </p-calendar>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Purchase End Date:</label>
      <p-calendar formControlName="endDate" icon="pi pi-calendar" class="font-20 margin-l-10" name="endDate"
        [defaultDate]="tomorrowEod" [showIcon]="true" dateFormat="d/m/yy" (ngModelChange)="changeInDate()"
        [selectOtherMonths]="true" showTime="true" hourFormat="24" [showButtonBar]="true" [minDate]="minEndDate"
        [stepMinute]="30">
      </p-calendar>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Subscription Priority:</label>
      <input formControlName="priority" class="flex-grow font-20 margin-l-10" name="priority" type="number" />
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Rule Type</label>
      <ng-select formControlName="ruleType" name="ruleType" class="flex-grow font-20 margin-l-10" [disabled]="true">
        <ng-option value="qualityReset">Quality Reset</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Validity Type:</label>
      <ng-select [ngModel]="'dapr'" [ngModelOptions]="{standalone: true}" [disabled]="true"
        class="flex-grow font-20 margin-l-10">
        <ng-option value="dapr">dapr</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Min Value:</label>
      <input formControlName="minValue" class="flex-grow font-20 margin-l-10 no-spinner" name="minValue"
        type="number" min="1" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNonPositiveAmount($event, 'minValue')"
        (wheel)="$event.preventDefault()" />
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Purchase Price:</label>
      <input formControlName="ruleAmount" class="flex-grow font-20 margin-l-10 no-spinner" name="ruleAmount"
        type="number" min="1" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNonPositiveAmount($event, 'ruleAmount')"
        (wheel)="$event.preventDefault()" />
    </div>
    <div class="flex-row">
      <label class="width-50"></label>
      <span class="field-info margin-l-10">{{ taxInfoText }}</span>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Original Price:</label>
      <input formControlName="strikedOutAmount" class="flex-grow font-20 margin-l-10 no-spinner"
        name="strikedOutAmount" type="number" min="1" (keydown)="blockInvalidNumberKeys($event)"
        (input)="rejectNonPositiveAmount($event, 'strikedOutAmount')" (wheel)="$event.preventDefault()"
        pTooltip="Optional: Enter amount more than Purchase Price" />
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Period In Days:</label>
      <input formControlName="periodInDays" class="flex-grow font-20 margin-l-10" name="periodInDays"
        type="number" min="1" step="1" />
    </div>

    <div class="margin-y-10 flex-row pull-right">
      <button mat-raised-button class="btn-primary" (click)="createDaprResetRule()"> Create Rule </button>
    </div>
  </form>
</div>
<app-toaster [config]="toasterService.toaster"></app-toaster>

<ng-template #OverlappingPriorityRuleAlert>
  <h3 matDialogTitle>Overlapping Subscription Rules with same priority</h3>
  <table class="table table-striped table-bordered outerTable">
    <thead>
      <tr>
        <th>Rule Id</th>
        <th>Rule name</th>
        <th>Priority</th>
        <th>Amount</th>
        <th>Start Time</th>
        <th>End Time</th>
        <th>Period In Days</th>
        <th>Comission Type</th>
        <th>Validity Type</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rule of overlappingRules">
        <td class="displayStyle">{{rule.id}}</td>
        <td class="displayStyle">{{rule.ruleName}}</td>
        <td class="displayStyle">{{rule.priority}}</td>
        <td class="displayStyle">{{rule.ruleAmount}}</td>
        <td class="displayStyle">{{Utils.dateFromEpoch(rule.startTime*1000)}}</td>
        <td class="displayStyle">{{Utils.dateFromEpoch(rule.endTime*1000)}}</td>
        <td class="displayStyle">{{rule.periodInDays}}</td>
        <td class="displayStyle">{{rule.ruleType}}</td>
        <td class="displayStyle">{{rule.validity && rule.validity.length > 0 ? rule.validity[0].type : "unlimited"}}</td>
      </tr>
    </tbody>
  </table>
  <span>Please create a Subscription Rule with other priority to proceed</span>
  <div mat-dialog-actions class="button-flex" style="float:right;">
    <button mat-button matDialogClose>ok</button>
  </div>
</ng-template>
